var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeFingers4645729(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.918,
    height: 20,
    viewBox: "0 0 11.918 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "three-fingers_4645729",
    transform: "translate(-105.446 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49778",
    "data-name": "Path 49778",
    d: "M113.273,8.3l2-5.505a1.25,1.25,0,0,0-2.328-.911l-2,5.518h0V1.25a1.25,1.25,0,0,0-2.5,0V7.387l-1.537-5.364a1.25,1.25,0,1,0-2.389.736L105.979,8.1a1.315,1.315,0,0,0-2.533.544v4.817l1.25,3.916V20h8.575l0-3.148,1.416-1.875V11.865a2.4,2.4,0,0,0-1.418-2.188,2.376,2.376,0,0,0-.979-.209H109.6a2.409,2.409,0,0,0,2.59,1.786v1.172a2.666,2.666,0,0,0-2.663,2.664v.583h-1.172V15.09a3.835,3.835,0,0,1,1.7-3.183,3.545,3.545,0,0,1-1.7-3.024V8.3Z",
    transform: "translate(2 5)",
    fill: "#7263d6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeFingers4645729);
export default __webpack_public_path__ + "static/media/three-fingers_4645729.946699485d3e88b2ed9f6e4667d0088b.svg";
export { ForwardRef as ReactComponent };